module.exports = __webpack_public_path__ + "img/clock-seven-thirty.d9089320.svg";